import React, { useState } from 'react'
import FilterMatchesScreen from './FilterMatchesScreen'
import { useSelector } from 'react-redux'

function NewMatches() {
    const {user} = useSelector(state => state.user)
    // eslint-disable-next-line
    const [matches, setMatches] = useState(user.newMatches)

    


    return (
        <FilterMatchesScreen user={user} matches={matches} title="New Members who match most of your Preferences" />
    )
}

export default NewMatches